var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8261 19.8689V29.3037C15.8261 30.7917 14.6184 31.9993 13.1304 31.9993H3.69565C2.20765 31.9993 1 30.7917 1 29.3037V9.08628C1 7.59828 2.20765 6.39062 3.69565 6.39062H7.73913",
    stroke: "#217A73",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73913 11.7812H1",
    stroke: "#217A73",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8261 26.6094H1",
    stroke: "#217A73",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39111 9.08594H7.73894",
    stroke: "#217A73",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0001 11.1087C32.0001 12.2247 31.0944 13.1304 29.9784 13.1304H22.5653L18.5218 17.1739V13.1304H13.8045C12.6885 13.1304 11.7827 12.2247 11.7827 11.1087V3.02174C11.7827 1.90574 12.6885 1 13.8045 1H29.9784C31.0944 1 32.0001 1.90574 32.0001 3.02174V11.1087V11.1087Z",
    stroke: "#217A73",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5655 5.71875C22.1935 5.71875 21.8916 6.02201 21.8916 6.39266C21.8916 6.76466 22.1935 7.06658 22.5655 7.06658C22.9375 7.06658 23.2394 6.76466 23.2394 6.39266C23.2394 6.02201 22.9375 5.71875 22.5655 5.71875Z",
    fill: "#217A73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6085 5.71875C26.2365 5.71875 25.9346 6.02201 25.9346 6.39266C25.9346 6.76466 26.2365 7.06658 26.6085 7.06658C26.9805 7.06658 27.2824 6.76466 27.2824 6.39266C27.2824 6.02201 26.9805 5.71875 26.6085 5.71875Z",
    fill: "#217A73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.564 5.71875C18.192 5.71875 17.8901 6.02201 17.8901 6.39266C17.8901 6.76466 18.192 7.06658 18.564 7.06658C18.936 7.06658 19.238 6.76466 19.238 6.39266C19.238 6.02201 18.936 5.71875 18.564 5.71875Z",
    fill: "#217A73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0866 29.3028C9.0866 29.6748 8.78468 29.9767 8.41268 29.9767C8.04068 29.9767 7.73877 29.6748 7.73877 29.3028C7.73877 28.9308 8.04068 28.6289 8.41268 28.6289C8.78468 28.6289 9.0866 28.9308 9.0866 29.3028V29.3028Z",
    stroke: "#217A73",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/sms_icon.17101d073bcf4968c43b048e579dfbfa.svg";
export { ForwardRef as ReactComponent };